import { render, staticRenderFns } from "./RelatorioListaMaterialView.vue?vue&type=template&id=c1792700&scoped=true"
import script from "./RelatorioListaMaterialView.vue?vue&type=script&lang=js"
export * from "./RelatorioListaMaterialView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1792700",
  null
  
)

export default component.exports